const ACTIVE_STATUSES = new Set(['pending', 'encamino']);

export function normalizeRecipientPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  // Peru's country prefix is optional in store-provided phone numbers.
  if (/^0051\d{9}$/.test(digits)) return digits.slice(4);
  if (/^51\d{9}$/.test(digits)) return digits.slice(2);
  return digits.length >= 9 && digits.length <= 15 ? digits : '';
}

export function normalizeComparisonText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function findPossibleRepetitions(deliveryPoints) {
  const byPhoneAndProduct = new Map();

  for (const point of deliveryPoints || []) {
    if (point?.id == null) continue;
    const phone = normalizeRecipientPhone(point.recipient_phone);
    const product = normalizeComparisonText(point.product);
    if (!phone || !product) continue;

    const key = `${phone}\u0000${product}`;
    if (!byPhoneAndProduct.has(key)) byPhoneAndProduct.set(key, new Map());
    byPhoneAndProduct.get(key).set(String(point.id), point);
  }

  return Array.from(byPhoneAndProduct, ([key, pointMap]) => {
    const points = Array.from(pointMap.values()).sort((a, b) => Number(b.id) - Number(a.id));
    const names = new Map();
    points.forEach((point) => {
      const normalizedName = normalizeComparisonText(point.recipient_name);
      if (normalizedName && !names.has(normalizedName)) names.set(normalizedName, point.recipient_name);
    });
    const stores = new Set(points.map((point) => point.user_id).filter((id) => id != null).map(String));

    return {
      key,
      phone: points[0].recipient_phone,
      product: points[0].product,
      points,
      names: Array.from(names.values()),
      namesDiffer: names.size > 1,
      storesDiffer: stores.size > 1,
      activeCount: points.filter((point) => ACTIVE_STATUSES.has(point.status)).length,
    };
  })
    .filter((group) => group.points.length > 1)
    .sort((a, b) => b.activeCount - a.activeCount || b.points.length - a.points.length || a.key.localeCompare(b.key));
}
